import React from "react";
import data from "../json/Allproducts/XperttrackPPMS.json";
import Section1 from "../components/Allproducts/Section1";
import Section4 from "../components/Allproducts/Section4";
import SEO from "../components/SEO";

const xpertTrackSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "XPERT-Track - PPMS",
  "brand": {
    "@type": "Brand",
    "name": "Transforma Pvt Ltd"
  },
  "logo": "https://www.transforma.in/images/transformalogo.svg",
  "description": "XPERT-Track - PPMS is an advanced Production Process Management System designed to optimize project workflows with auto file movement, auto emailing, and real-time tracking."
  
};


const Xperttrack = () => {
  return (
    <>
    <SEO 
        title="XPERT-Track PPMS | Production Process Management & Automation"
        description="Optimize publishing workflows with XPERT-Track PPMS. Features automated file movement, auto emailing, real-time tracking, and centralized dashboards to minimize manual intervention."
        keywords="XPERT-Track, PPMS, Production Process Management System, workflow automation, auto file movement, automated emailing, real-time project tracking, publishing dashboard, resource management software"
        canonical="https://www.transforma.in/products/xperttrack"
        schema={xpertTrackSchema}
      />
    <div className="w-full flex flex-col items-center ruler">
      <Section1 data={data} />
      <Section4 data={data.Section4} />
    </div>
    </>
  );
};

export default Xperttrack;
